/**
 * Make time-string to correct with seconds if its not (hh:mm -> hh:mm:ss)
 * @param val time-string
 */
function setCorrectTimeFormat(val: string | null): string | null {
	if (val === null) {
		return null;
	}
	if (val.length === 5) {
		return val.concat(':00');
	}
	else {
		return val;
	}
}

/**
 * Get date object in UTC zone from date-string (ISO) and time-string
 * @param date string in ISO
 * @param time string in hh:mm:ss format
 */
function getDateTimeUTC(date: string, time: string): Date {
	const [year, month, day] = date.split('-').map((v) => parseInt(v, 10));
	const [hour, minute, second] = setCorrectTimeFormat(time)!.split(':').map((v) => parseInt(v, 10));
	const dateObj = Date.UTC(year, month - 1, day, hour, minute, second);
	return new Date(dateObj);
}
/**
 * Get date object in UTC zone from date-string (ISO) and time-string
 * @param date string in ISO
 *
 */
function getDateUTC(date: string): Date {
	const [year, month, day] = date.split('-').map((v) => parseInt(v, 10));
	const dateObj = Date.UTC(year, month - 1, day);
	return new Date(dateObj);
}

function toUTCDateOnly(date: Date): string {
	return date.toISOString().substr(0, 10);
}

/**
 * Convert date-string from [yyyy-mm-dd] to [dd.mm.yyyy] format
 * @param date string in [yyyy-mm-dd] format
 */
function formatDateToRussian(date: string | null): string | null {

	const padLeft = (val: number) => val.toString().padStart(2, '0');

	if (!date) { return null; }
	const [year, month, day] = date.split('-').map((v) => parseInt(v, 10));
	return `${padLeft(day)}.${padLeft(month)}.${year}`;
}

export { setCorrectTimeFormat, getDateUTC, getDateTimeUTC, toUTCDateOnly, formatDateToRussian };
